import { MinimalMultiTabDialogTrigger } from './MinimalMultiTabDialog';
export default MinimalMultiTabDialogTrigger;
